module.exports = __webpack_public_path__ + "img/stock3.c1ea5eb2.png";